import del from './delete';
import get from './get';
import source from './source';
import test from './test';
import put from './put';

export default { del, get, put, test, source };
